// extracted by mini-css-extract-plugin
export default {"events-summary":"styles_events-summary__wKewl","no-events":"styles_no-events__9clF8"};